import type { LogoProps } from '../../logo.types'

import { logos, symbols } from './logos'

type LogoDrogasilProps = LogoProps & {
  onlySymbol?: boolean
}

export const LogoDrogasil = (props: LogoDrogasilProps) => {
  const { size, type, onlySymbol = false } = props

  const SvgComponent = logos[type][size]

  const SymbolComponent = symbols[type][size]

  return onlySymbol ? SymbolComponent : SvgComponent
}
